import './DropdownTrigger.scss';

export { default } from './DropdownTrigger';
